<template>
  <div>
    <template v-if="type==='edit'">
      <cus-btn
        v-if="(isMultiple||(fileList.length==0&&!isMultiple))&&!isTextButton"
        type="upload"
        @click="uploadFile"
      ></cus-btn>
      <el-button v-if="isTextButton" :type="'text'" @click="uploadFile">{{ $t("checkList.upload") }}</el-button>
      <slot></slot>
      <div v-for="(file,i) in fileList" :key="i">
        <div class="filename-box">
          <img class="filename-box-clip" src="../../assets/checklist/clip.png" />
          <div class="filename-box-clip-right">
            <div class="filename-box-clip-right-top">
              <div
                class="filename-box-filename"
                @click="downloadFile(file)"
              >{{ getfileName(file.filename||file.pathFileName) }}</div>
              <img
                class="filename-box-close"
                src="../../assets/checklist/close.png"
                @click="removeFile(file)"
              />
            </div>
            <div v-if="file.progress!==100" class="filename-box-clip-right-bottom">
              <div :style="{backgroundColor:'#1890FF',width:file.progress+'%'}" />
            </div>
          </div>
        </div>
      </div>
    </template>
    <template v-if="type==='view'">
      <slot></slot>
      <div v-for="(file,i) in fileList" :key="i" class="file-view-box">
        <img class="filename-box-clip" src="../../assets/checklist/clip.png" />
        <div class="filename-box-filename">{{ getfileName(file.filename||file.pathFileName) }}</div>
        <i class="el-icon-download" @click="downloadFile(file)" />
      </div>
    </template>
  </div>
</template>

<script>
import request from "@/utils/request";
import axios from "axios";
export default {
  components: {},
  props: {
    // 类型 edit编辑    view查看状态
    type: {
      type: String,
      default: "view"
    },
    fileList: {
      type: Array,
      default: () => {
        return [];
      }
    },
    isMultiple: {
      type: Boolean,
      default: true
    },
    isTextButton: {
      type: Boolean,
      default: false
    },
    showIcon: {
      type: Boolean,
      default: true
    },
    extAllow: {
      type: String,
      default: ""
    },
    sizeForbid: {
      type: Number,
      default: 200
    }
  },
  data() {
    return {};
  },
  computed: {},
  watch: {},
  created() {
    if(this.type=='edit'){
      for(var m in this.fileList) {
         this.fileList[m].progress=100;
      }
    }
  },
  mounted() {},
  methods: {
    uploadFile() {
      const uploader = document.createElement("input");
      uploader.type = "file";
      uploader.style.setProperty("display", "none");
      document.body.appendChild(uploader);
      uploader.onchange = () => {
        if (this.extAllow) {
          var extAllowList = this.extAllow.split(",");
          if (
            extAllowList.filter(item => {
              return uploader.files[0].name
                .toUpperCase()
                .endsWith(item.toUpperCase());
            }).length == 0
          ) {
            this.$message(this.$t("checkList.onlyExtensions", [this.extAllow]));
            return;
          }
        }
        if (this.sizeForbid * 1024 * 1024 < uploader.files[0].size) {
          this.$message(this.$t("checkList.fileMaxSize", [this.sizeForbid]));
          return;
        }
        this.$emit("fileadd");
        const formData = new FormData();
        formData.append("file", uploader.files[0]);
        var temp = {
          filename: uploader.files[0].name,
          progress: 0,
          filepath: "",
          pathFileName: ""
        };
        request({
          url: axios.defaults.baseURL + "/common/file/upload",
          method: "post",
          data: formData,
          timeout: 300000,
          onUploadProgress: progressEvent => {
            temp.progress = parseInt(
              (progressEvent.loaded / progressEvent.total) * 100
            );
          }
        }).then(res => {
          temp.filepath = res.data.path;
          temp.pathFileName = res.data.fileName;
          document.body.removeChild(uploader);
        });
        this.fileList.push(temp);
      };
      uploader.click();
    },
    removeFile(file) {
      this.$emit("fileremove");
      this.fileList.splice(this.fileList.indexOf(file), 1);
    },
    getfileName(str) {
      if (str) {
        if (str.length > 20) {
          const temp = str.substring(str.lastIndexOf(".") - 1, str.length);
          const newName =
            str.substring(0, str.lastIndexOf(".")).substring(0, 18) +
            "..." +
            temp;
          return newName;
        } else {
          return str;
        }
      } else {
        return "";
      }
    },
    downloadFile(file) {
      if (file && file.filepath) {
        window.open(file.filepath);
      }
    }
  }
};
</script>
<style  scoped>
.filename-box {
  margin-top: 15px;
  display: flex;
}
.filename-box img {
  height: 14px;
  margin-top: 2px;
}
.filename-box-clip-right {
  margin-left: 4px;
  width: 280px;
}
.filename-box-clip-right-top {
  display: flex;
  justify-content: space-between;
  line-height: 18px;
  cursor: pointer;
}
.filename-box-filename {
  color: rgba(0, 0, 0, 0.45);
  line-height: 14px;
  font-size: 14px;

}
.filename-box-clip-right-top img {
  cursor: pointer;
}
.filename-box-clip-right-bottom {
  margin-top: 4px;
  height: 2px;
  background: rgba(0, 0, 0, 0.04);
  border-radius: 30px;
}
.filename-box-clip-right-bottom div {
  height: 100%;
  width: 0;
}

.file-view-box {
  display: flex;
  margin-top: 5px;
}
.file-view-box img {
  height: 14px;
  margin-top: 2px;
  margin-right: 4px;
}
.file-view-box i {
  font-size: 14px;
  color: #029fe7;
  cursor: pointer;
  margin-left: 32px;
}
</style>
